import { LayoutProps } from '@/components/layout/types';
import clsx from 'clsx';
import { renameDomProps } from '@/utils/sanitizeDomProps';
import { variantClass } from '../share-socials/const';

export function Layout({
  variant = 'fullBleed',
  marginBottom,
  verticalSpacing,
  backgroundColor = 'white',
  children,
  className,
  ...rest
}: LayoutProps) {
  const resolvedVariantClass =
    variantClass[variant as keyof typeof variantClass];
  const marginBottomStyle =
    typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom;
  // Handle verticalSpacing
  const verticalSpacingStyle =
    typeof verticalSpacing === 'number'
      ? `${verticalSpacing}px`
      : verticalSpacing;
  const renamedProps = renameDomProps(rest);
  return (
    <section
      data-component-id="C012"
      className={clsx(
        `smzh-layout flex flex-col ${resolvedVariantClass}`,
        className,
      )}
      style={{
        marginBottom: marginBottomStyle,
        backgroundColor: backgroundColor,
        gap: verticalSpacingStyle,
      }}
      {...renamedProps}
    >
      {children}
    </section>
  );
}
